<script setup lang="ts">
const model = defineModel()
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  field: {
    type: String,
    required: true
  },
  optionLabel: {
    type: String,
    default: 'label'
  },
  optionValue: {
    type: String,
    default: 'value'
  }
})

function onChangeStatus() {
  if (!model.value) {
    model.value = props.field
  } else if (model.value === props.field) {
    model.value = `-${props.field}`
  } else {
    model.value = ''
  }
}

</script>

<template>
  <button class="flex gap-2 items-center p-1" @click="onChangeStatus">
    <span class="text-xs">{{ props.title }}</span>
    <i v-if="model === props.field" class="pi pi-arrow-up" style="font-size: 1rem;"></i>
    <i v-if="model === `-${props.field}`" class="pi pi-arrow-down" style="font-size: 1rem;"></i>
  </button>
</template>
